
import {defineComponent} from 'vue';

export default defineComponent({
  setup() {

const scrollTop = () => {
  window.scrollTo(0, 0)
}


    return {
      scrollTop,
    };
  },
})
